import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { environment } from '@meplis/environments';

/**
 * Chatroom entry point. Rendered in the desktop headers and inside the mobile
 * bottom nav, so the badge/counter logic lives in one place.
 *
 * Hidden in production while chat is still being rolled out -- the template
 * renders nothing at all rather than a disabled button, so neither entry
 * point (the header's mat-menu trigger, or the bottom nav slot) shows a
 * dead icon.
 */
@Component({
  selector: 'app-chat-button',
  standalone: true,
  imports: [CommonModule, TranslatePipe, MatButtonModule, FaIconComponent],
  templateUrl: './chat-button.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './chat-button.component.scss',
})
export class ChatButtonComponent {
  @Input() public unreadCount = 0;
  /** Renders the label under the icon (bottom-nav style) instead of icon-only. */
  @Input() public showLabel = false;
  @Input() public isActive = false;

  @Output() public chatClicked = new EventEmitter<void>();

  public readonly isHidden = environment.production;

  /** Badges stop counting at 99 so the pill keeps its shape. */
  public get badgeLabel(): string {
    return this.unreadCount > 99 ? '99+' : String(this.unreadCount);
  }

  public onClick(): void {
    this.chatClicked.emit();
  }
}
